@if(mentorSignUpDetails(); as details) {
<div class="mentor-sign-up-details-part bg-light rounded shadow-sm h-100">
	<div class="pt-2 ps-1">
		<h5>
			<span class="badge bg-secondary-subtle text-black px-3 py-2">
				Status : {{details.volunteerSignupMentorStatus}}
			</span>
		</h5>
	</div>

	<div class="p-3 pt-0">
		<div class="row mb-4">
			<div class="col-12"></div>
			<div class="d-flex flex-column gap-2">
				<div class="d-flex">
					<div class="fw-bold me-2">Mentor:</div>
					<span role="button" class="text-decoration-underline"
						(click)="openPersonDialog(details.person.id)">
						{{details.person.fullName}}
					</span>
				</div>
			</div>
			<div class="d-flex">
				<div class="fw-bold me-2">Trimester:</div>
				<div>{{details.trimesterName}}</div>
			</div>
			<div class="d-flex">
				<div class="fw-bold me-2">Sign-Up Created Date:</div>
				<div>{{details.formattedCreatedUTC}}</div>
			</div>
			<div class="d-flex mt-4">
				<div class="fw-bold me-2">Selected Language:</div>
				<div>{{details.selectedLanguage}}</div>
			</div>
			<div class="d-flex">
				<div class="fw-bold me-2">Approved Languages:</div>
				<div>{{details.approvedLanguages}}</div>
			</div>
			<div class="d-flex">
				<div class="fw-bold me-2">Assigned Language:</div>
				<div>{{details.assignedLanguageId}}</div>
			</div>
			<div class="d-flex mt-4">
				<div class="fw-bold me-2">Weekly meetings available:</div>
				<div>{{details.mentorSchedule?.numMeetings ?? 'N/A'}}</div>
			</div>
			<div class="d-flex mt-4">
				<div class="fw-bold me-2">Notes:</div>
				<div>{{details.note||'N/A'}}</div>
			</div>
		</div>
	</div>
</div>
}